import { componentQrl, inlinedQrl, useVisibleTaskQrl, _jsxC, Fragment, Slot } from "@builder.io/qwik";
const Awaiter = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  useVisibleTaskQrl(/* @__PURE__ */ inlinedQrl(() => {
  }, "Awaiter_component_useVisibleTask_GMx1IPL7vl0"));
  return /* @__PURE__ */ _jsxC(Fragment, {
    children: /* @__PURE__ */ _jsxC(Slot, null, 3, "iM_0")
  }, 1, "iM_1");
}, "Awaiter_component_Uc1j2U3wluQ"));
export {
  Awaiter,
  Awaiter as default
};
